import parseCAPIMessage from "@tvg/utils/capiUtils";
import { Store } from "redux";
import { defaultSpecialWagerTooltipDescription } from "./defaultValues";
import { SpecialWagerTooltipDescription } from "../types";

export const getSpecialWagerTooltipDescription = (
  store: Store
): SpecialWagerTooltipDescription =>
  parseCAPIMessage(
    store,
    "capi.messages.specialWagerTooltipDescription",
    defaultSpecialWagerTooltipDescription
  );
